var React = require('react');

function DescBgTriangle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2 42.2539L55.7092 74.306M2 42.2539L39.1662 41.2273M2 42.2539L62.2844 24.5726M55.7092 74.306L39.1662 41.2273M55.7092 74.306L62.2844 24.5726M39.1662 41.2273L62.2844 24.5726","stroke":"#553E6B"}));
}

DescBgTriangle.defaultProps = {"width":"84","height":"81","viewBox":"0 0 84 81","fill":"none"};

module.exports = DescBgTriangle;

DescBgTriangle.default = DescBgTriangle;
